/*
 * CARVERHAUS finish list (blocks/ch-finish-info.liquid).
 * Moves the "Selected" mark to the colour chosen in the variant picker,
 * since the product page does not re-render this block on a variant change.
 */
if (!customElements.get('ch-finish-info')) {
  customElements.define(
    'ch-finish-info',
    class ChFinishInfo extends HTMLElement {
      connectedCallback() {
        document.addEventListener('change', this.#onChange);
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.#onChange);
      }

      get #colour() {
        const picker = this.closest('.product-details')?.querySelector('variant-picker');
        for (const fieldset of picker?.querySelectorAll('fieldset') ?? []) {
          const legend = fieldset.querySelector('legend')?.textContent?.trim().toLowerCase() ?? '';
          if (/^(colou?r|finish|wood)/.test(legend)) {
            const checked = /** @type {HTMLInputElement | null} */ (fieldset.querySelector('input:checked'));
            return checked?.value?.trim().toLowerCase() ?? null;
          }
        }
        return null;
      }

      #onChange = (event) => {
        const target = /** @type {HTMLElement} */ (event.target);
        if (!target.closest?.('variant-picker')) return;
        if (target.closest('.product-details') !== this.closest('.product-details')) return;
        const colour = this.#colour;
        if (!colour) return;
        for (const item of this.querySelectorAll('[data-ch-finish]')) {
          item.classList.toggle('is-current', item.getAttribute('data-ch-finish') === colour);
        }
      };
    }
  );
}
